export default {
    show: 'إظهار',
    'archived': 'مؤرشفة',
    'revolved': 'مدورة',
    'locked': 'مقفلة',
    'active': 'فعالة',
    'no-$-financial-files': 'لا يوجد ملفات مالية {state}',

    'revolved-to-$': 'مدور إلى  "{financialFile}"',
    "welcome": "أهلا بك",
    "there-is-no-financial-file-so-create-your-financial-file": "لم تقم بإنشاء أية ملفات مالية بعد ؟ إبدأ بإنشاء ملفك المالي الآن !",
    "create-financial-file": "إنشاء ملف مالي",
    'did-not-create-any-financial-files': 'لم يتم إضافة أية ملفات مالية بعد...',
}